export const HOME = { emergentLink: "emergent-link" };

export const T = {
  navLogo: "navbar-brand-logo",
  navShop: "navbar-shop-link",
  navHeritage: "navbar-heritage-link",
  navAdmin: "navbar-admin-link",
  navCart: "navbar-cart-button",
  navAccount: "navbar-account-link",
  authTabSignin: "auth-tab-signin",
  authTabRegister: "auth-tab-register",
  authRegisterName: "auth-register-name-input",
  authRegisterSubmit: "auth-register-submit-button",
  authError: "auth-error",
  checkoutUseCredit: "checkout-use-credit-checkbox",
  accountCredit: "account-credit-balance",
  accountSaveAddress: "account-save-address-button",
  adminGrantCredit: (id) => `admin-grant-credit-${id}`,
  adminRefundCard: (id) => `admin-refund-card-${id}`,
  adminRefundCredit: (id) => `admin-refund-credit-${id}`,
  heroExplore: "hero-explore-button",
  heroShop: "hero-shop-button",
  productCard: (id) => `product-card-${id}`,
  productSizeSelect: (id) => `product-size-select-${id}`,
  productColourSelect: (id) => `product-colour-select-${id}`,
  productAddToCart: (id) => `product-add-to-cart-${id}`,
  productBuyNow: (id) => `product-buy-now-${id}`,
  cartCheckout: "cart-drawer-checkout-button",
  checkoutPay: "checkout-stripe-pay-button",
  adminLoginEmail: "admin-login-email-input",
  adminLoginPassword: "admin-login-password-input",
  adminLoginSubmit: "admin-login-submit-button",
  adminAddProduct: "admin-add-product-button",
  adminOrderTemu: (id) => `admin-order-temu-link-${id}`,
  adminOrderStatus: (id) => `admin-order-status-${id}`,
  adminProductSave: "admin-product-save-button",
};
